import "./LioniaProject.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CoreAudienceEditorial from "./sections/CoreAudienceEditorial";
import FoundationalPillars from "./sections/FoundationalPillars";
import Ecosystemsynergy from "./sections/Ecosystemsynergy";
import Impactmetrics from "./sections/Impactmetrics";
import ContentEcosystemGrid from "./sections/ContentEcosystemGrid";
import StorytellingBanner from "./sections/StorytellingBanner";
import ConcreteReasons from "./sections/ConcreteReasons";
import ValuesMasonryGrid from "./sections/ValuesMasonryGrid";
import Footer from "@/reusable_sections/Footer";
export default function LioniaProjectPage() {
  return <div>
      <Header />
      <Hero />
      <CoreAudienceEditorial />
      <FoundationalPillars />
      <Ecosystemsynergy />
      <Impactmetrics />
      <ContentEcosystemGrid />
      <StorytellingBanner />
      <ConcreteReasons />
      <ValuesMasonryGrid />
      <Footer />
    </div>;
}